import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c3aa64c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-bg-w-cultured rounded p-25",
  style: {"min-height":"270px","box-shadow":"0 3px 6px #2222221A"}
}
const _hoisted_2 = {
  id: "myTab",
  class: "nav nav-tabs justify-content-center px-0 d-flex mb-20 gap-30",
  role: "tablist"
}
const _hoisted_3 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_4 = ["aria-selected", "innerHTML"]
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = ["aria-selected", "innerHTML"]
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = ["aria-selected", "innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "my-5",
  style: {"border":"1px solid #EAEFFD"}
}, null, -1 /* HOISTED */))
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "my-5",
  style: {"border":"1px solid #EAEFFD"}
}, null, -1 /* HOISTED */))
const _hoisted_17 = ["src"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "d-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_PlaceModal = _resolveComponent("PlaceModal")!
  const _component_MapModal = _resolveComponent("MapModal")!
  const _component_ListingTypologyMultiSelectModal = _resolveComponent("ListingTypologyMultiSelectModal")!
  const _component_ValuationTypologyModal = _resolveComponent("ValuationTypologyModal")!
  const _component_BaseSnackbar = _resolveComponent("BaseSnackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          id: "sale-tab",
          class: _normalizeClass(["nav-link f-14 bg-w-cultured", {active:_ctx.searchBean.sale}]),
          "data-toggle": "tab",
          "data-field-target": "Contratto",
          "data-value": "1",
          role: "tab",
          "aria-selected": _ctx.searchBean.sale,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.updateContractType(_ctx.enumContract.SALE)), ["prevent"])),
          innerHTML: _ctx.labels.homeSale
        }, null, 10 /* CLASS, PROPS */, _hoisted_4)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("a", {
          id: "rent-tab",
          class: _normalizeClass(["nav-link f-14 bg-w-cultured", {active:_ctx.searchBean.rent}]),
          "data-toggle": "tab",
          "data-field-target": "Contratto",
          "data-value": "2",
          role: "tab",
          "aria-selected": _ctx.searchBean.rent,
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.updateContractType(_ctx.enumContract.RENT)), ["prevent"])),
          innerHTML: _ctx.labels.homeRent
        }, null, 10 /* CLASS, PROPS */, _hoisted_6)
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("a", {
          id: "valuation-tab",
          class: _normalizeClass(["nav-link f-14 bg-w-cultured", {active: _ctx.sellingIsActive}]),
          "data-toggle": "tab",
          "data-field-target": "Vendi",
          role: "tab",
          "aria-selected": _ctx.sellingIsActive,
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.updateContractType(_ctx.enumContract.SELLING)), ["prevent"])),
          innerHTML: _ctx.labels.sell
        }, null, 10 /* CLASS, PROPS */, _hoisted_8)
      ])
    ]),
    _createCommentVNode("        SEARCH"),
    _createElementVNode("div", {
      class: _normalizeClass(["bg-white rounded px-20 py-10", {'d-none': _ctx.sellingIsActive}]),
      style: {"border":"1px solid #E9EFFE"}
    }, [
      _createVNode(_component_base_button, {
        id: "listing-typology-multiselect-mobile",
        "btn-class": "btn-block btn-search-box f-14 fw-medium text-start text-truncate px-0 border-0",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal(_ctx.Modals.listingTypologyMultiSelectModal)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.labelSelectedMultiSelectionTypology), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _hoisted_9,
      _createElementVNode("div", {
        class: "fake-input bg-white py-10 d-flex align-items-center position-relative",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openPlaceModal()))
      }, [
        (!_ctx.searchBean.placeId)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: `${_ctx.cdn}/_ui/img/Ico/zoom-blue.svg`,
              alt: "luogo",
              class: "icon me-10",
              height: "15",
              width: "15"
            }, null, 8 /* PROPS */, _hoisted_10))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: `${_ctx.cdn}/_ui/img/Ico/zoom-blue.svg`,
              alt: "luogo",
              class: "icon me-10",
              height: "15",
              width: "15"
            }, null, 8 /* PROPS */, _hoisted_11)),
        (_ctx.searchBean.placeId)
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: "f-14 fw-medium text-truncate text-w-black",
              innerHTML: _ctx.currentPlaceName
            }, null, 8 /* PROPS */, _hoisted_12))
          : (_ctx.searchBean.polygonFromMap && !_ctx.radius)
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                class: "f-14 fw-semibold text-w-black",
                innerHTML: _ctx.labels.mapAreaDrawn
              }, null, 8 /* PROPS */, _hoisted_13))
            : (_ctx.radius)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 4,
                  class: "f-14 fw-semibold text-w-black",
                  innerHTML: _ctx.mapAroundYouLabel
                }, null, 8 /* PROPS */, _hoisted_14))
              : (_openBlock(), _createElementBlock("span", {
                  key: 5,
                  class: "f-14 text-w-secondary",
                  innerHTML: _ctx.labels.searchCityLong
                }, null, 8 /* PROPS */, _hoisted_15))
      ])
    ], 2 /* CLASS */),
    _createCommentVNode("        VALUATION"),
    _createElementVNode("div", {
      class: _normalizeClass(["bg-white rounded px-20 py-10", {'d-none' : !_ctx.sellingIsActive}]),
      style: {"border":"1px solid #E9EFFE"}
    }, [
      _createVNode(_component_base_button, {
        id: "listing-typology-valuation-mobile",
        "btn-class": "btn-block btn-search-box f-14 fw-medium text-start text-truncate px-0",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal(_ctx.Modals.listingValuationTypology)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.labelSelectedValuationTypology), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _hoisted_16,
      _createElementVNode("div", {
        class: "fake-input bg-white py-10 d-flex align-items-center position-relative",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openPlaceModal()))
      }, [
        (_ctx.place && _ctx.place.address)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("img", {
                src: `${_ctx.cdn}/_ui/img/Ico/zoom-blue.svg`,
                alt: "luogo",
                class: "icon me-10",
                height: "15",
                width: "15"
              }, null, 8 /* PROPS */, _hoisted_17),
              _createElementVNode("span", {
                class: "f-14 text-truncate text-w-black fw-medium",
                innerHTML: _ctx.place.address
              }, null, 8 /* PROPS */, _hoisted_18)
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("img", {
                src: `${_ctx.cdn}/_ui/img/Ico/zoom-blue.svg`,
                alt: "luogo",
                class: "icon me-10",
                height: "15",
                width: "15"
              }, null, 8 /* PROPS */, _hoisted_19),
              _createElementVNode("span", {
                class: "f-14 text-truncate text-w-secondary",
                innerHTML: _ctx.labels.enter_a_address
              }, null, 8 /* PROPS */, _hoisted_20)
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_base_button, {
        id: _ctx.sellingIsActive?'valuation-button':'search-button',
        "btn-class": "btn-w-primary btn-block mt-15 position-relative",
        "data-cy": "search-btn",
        "is-loading": _ctx.loading,
        disabled: _ctx.isDisabledBtn,
        onClick: _withModifiers(_ctx.manageClick, ["prevent","stop"])
      }, {
        default: _withCtx(() => [
          (!_ctx.sellingIsActive)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.labels.genericSearch), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.labels.sellNow), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["id", "is-loading", "disabled", "onClick"])
    ]),
    (_ctx.showModal === 'PLACE_MODAL' || _ctx.showModal === 'MAP_MODAL')
      ? (_openBlock(), _createBlock(_component_PlaceModal, {
          key: 0,
          "show-place-modal": true,
          valuation: _ctx.sellingIsActive,
          "top-city-list": _ctx.topCityList,
          place: _ctx.place,
          onShowMap: _cache[7] || (_cache[7] = value => _ctx.openMapModal(value)),
          onHidePlaceModal: _ctx.closeModal,
          onEmitPlace: _cache[8] || (_cache[8] = value => _ctx.getPlaceFromModal(value)),
          onEmitRadius: _cache[9] || (_cache[9] = value => _ctx.setRadiusAroundMe(value))
        }, null, 8 /* PROPS */, ["valuation", "top-city-list", "place", "onHidePlaceModal"]))
      : _createCommentVNode("v-if", true),
    (_ctx.showModal === 'MAP_MODAL')
      ? (_openBlock(), _createBlock(_component_MapModal, {
          key: 1,
          "show-map-modal": true,
          "around-me": _ctx.aroundMe,
          "previously-around-me": _ctx.previouslyAroundMe,
          onHideMapModal: _ctx.closeMapModal,
          onEmitPlace: _cache[10] || (_cache[10] = value => _ctx.getPlaceFromMapModal(value))
        }, null, 8 /* PROPS */, ["around-me", "previously-around-me", "onHideMapModal"]))
      : _createCommentVNode("v-if", true),
    (_ctx.showModal === 'LISTING_TYPOLOGY_MULTISELECT')
      ? (_openBlock(), _createBlock(_component_ListingTypologyMultiSelectModal, {
          key: 2,
          value: _ctx.searchBean.listingTypologyIdList,
          "show-listing-modal": true,
          "macro-typology-id": _ctx.searchBean.macroTypologyId,
          "listing-typologies": _ctx.listingTypologies,
          onCloseListingModal: _ctx.closeModal,
          onConfirmTypologies: _ctx.updateTypologyLabel,
          onInputObject: _cache[11] || (_cache[11] = options => {
        _ctx.searchBean.macroTypologyId = options.macroTypologyID;
        _ctx.searchBean.listingTypologyURL = options.url;
        _ctx.searchBean.listingTypologyId = options.listingTypologyId;
        _ctx.searchBean.listingTypologyIdList = options.selectedListingTypologiesIDList;
        _ctx.searchBean.typologyIdList = options.selectedTypologiesIDList;
      })
        }, null, 8 /* PROPS */, ["value", "macro-typology-id", "listing-typologies", "onCloseListingModal", "onConfirmTypologies"]))
      : _createCommentVNode("v-if", true),
    (_ctx.showModal === 'LISTING_VALUATION_TYPOLOGY')
      ? (_openBlock(), _createBlock(_component_ValuationTypologyModal, {
          key: 3,
          "show-valuation-typology-modal": true,
          "valuation-typology-id": _ctx.valuationTypologyId,
          "last-valuation-typology-id": _ctx.lastValuationTypologyId,
          onCloseValuationTypologyModal: _ctx.closeModal,
          onSelectedTypology: _ctx.manageSelectedTypology
        }, null, 8 /* PROPS */, ["valuation-typology-id", "last-valuation-typology-id", "onCloseValuationTypologyModal", "onSelectedTypology"]))
      : _createCommentVNode("v-if", true),
    (_ctx.showBaseSnackbar)
      ? (_openBlock(), _createBlock(_component_BaseSnackbar, {
          key: 4,
          title: _ctx.baseSnackbarProps.title,
          body: _ctx.baseSnackbarProps.title
        }, null, 8 /* PROPS */, ["title", "body"]))
      : _createCommentVNode("v-if", true)
  ]))
}